/**
 *  Enumeration used for defining header content types. 
 **/
export enum ContentType {
    JSON = "application/json",
    XML = "application/xml"
}